<template>
  <div class="xunlinEchartPage">
    <p class="dw">次</p>
    <ve-line
      :data="chartData"
      :init-options="initOptions"
      :settings="chartSettings"
      :extend="chartExtend"
      :height="lineHeight"
    ></ve-line>
  </div>
</template>
<script>
/*eslint-disable*/
export default {
  name: "xunLinEchart",
  data() {
    this.chartDataZoom = [{ type: "slider" }];
    this.chartExtend = {
      legend: {  //抬头
        show: false,
      },
      // tooltip: {
      //   trigger: "axis",
      //   axisPointer: {
      //     // 坐标轴指示器，坐标轴触发有效
      //     type: "line", // 默认为直线，可选为：'line' | 'shadow'
      //   },
      // },
      xAxis: {
        type: "category",
        boundaryGap: true,

        // axisLabel: {
        //   interval: 4,
        //   rotate: 35,
        // },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#999",
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
            },
          },
        },
        // grid: {
        //   //    x: 40,
        //   x2: 10, //图与右侧的边距
        //   y2: 80, //图与下边的边距
        // },
      },
      yAxis: {
        axisLabel: {
          textStyle: {
            color: "#333",
            fontSize: 14,
          },
        },

        axisLine: {
          show: false,
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: "dashed",
          },
        },
      },
    };
    this.chartSettings = {
      area: true, //是否显示为面积图
      yAxisType: "linear",
      itemStyle: {
        //面积图颜色设置
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          // normal: {
          //   //设置折线折点
          //   color: "#FFDB9B",
          // },
          colorStops: [
            {
              offset: 0,
              color: "rgba(255, 167, 10, 1)", // 0% 处的颜色
            },
            {
              offset: 0.5,
              color: "rgba(255, 167, 10, .8)", // 100% 处的颜色
            },
            {
              offset: 0.7,
              color: "rgba(255, 167, 10, .5)", // 100% 处的颜色
            },
            {
              offset: 1,
              color: "rgba(255, 167, 10, .2)", // 100% 处的颜色
            },
          ],
          // globalCoord: false
        },
      },
    };
    this.initOptions = {
      renderer: "svg",
    };
    return {
      lineWidth: "100%", //宽度
      lineHeight: "330px", //高度
      chartData: {
        //数据
        columns: [],
        rows: [],
      },
      activeNumber: "",
    };
  },
  props: {
    echartActive: {
      type: String,
    },
  },
  mounted() {
    if (this.echartActive) {
      this.activeNumber =
        this.echartActive == "echartDay"
          ? 0
          : this.echartActive == "echartMonth"
          ? 1
          : 2;
      this.getEchartSource();
    }
  },
  methods: {
    getEchartSource() {
      let _this = this;
      _this.$api.xunLData
        .getxunLTrend(this.activeNumber)
        .then((res) => {
          if (res.code == "1" && res.data) {
            console.log(res.data);
            _this.chartData.columns = ["日期", "巡林次数"];
            _this.chartData.rows = [];
            let NewObject = {};

            for (let i = 0; i < res.data.length; i++) {
              NewObject = {
                日期: res.data[i].dateTime,
                巡林次数: res.data[i].xunLNum,
              };
              _this.chartData.rows.push(NewObject);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  watch: {
    echartActive(newValue) {
      if (newValue) {
        this.activeNumber =
          newValue == "echartDay" ? 0 : newValue == "echartMonth" ? 1 : 2;
        this.getEchartSource();
      }
    },
  },
};
</script>
<style lang="less">
.xunlinEchartPage{
  position: relative;
  .dw{
    position: absolute;
    top: 25px;
    left: 16px;
  }
}
</style>